<template>
  <div class="acc_leave">
    <van-icon name="cross" class="cross" @click="close"/>
    <div class="tit">提示</div>
    <p>
        退出后将不保存您的寄售信息<br/>
        确定取消发布
    </p>
    <div class="btns">
        <van-button round class="back_btn" @click="leave">狠心退出</van-button>
        <van-button round color="var(--theme)" @click="close">继续发布</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    close() {
        this.$emit('closeModal')
    },
    leave() {
        this.$emit('success')
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.acc_leave {
    position: relative;
    padding: 2.9rem 1.5rem 2.2rem;
    .cross {
        position: absolute;
        right: .8rem;
        top: .8rem;
        font-size: 1.8rem;
        color: #000;
        cursor: pointer;
    }
    .tit {
        font-size: 1.6rem;
        text-align: center;
        font-weight: 700;
        margin-bottom: 1.9rem;
        color: var(--theme);
    }
    p {
        font-size: 1.4rem;
        color: #555;
        line-height: 1.5;
        text-align: center;
        margin-bottom: 2.4rem;
    }
    .btns {
        display: flex;
        justify-content: space-between;
        .van-button {
            width: 12rem;
            height: 3.2rem;
            padding: 0;
            font-size: 1.4rem;
        }
        .back_btn {
            border-color: #999;
            color: #999;
        }
    }
}
</style>
